module.exports = __webpack_public_path__ + "static/media/siren.52c079ad.svg";